import ConsumerClaimDetailPanel from "./consumerClaimDetailPanel.container";

export default ConsumerClaimDetailPanel;